// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__LoBEd","colCheckbox":"styles_colCheckbox__SMU7K"};